import { render, staticRenderFns } from "./IncentifyerAccountsCard.vue?vue&type=template&id=29f80b9f&"
import script from "./IncentifyerAccountsCard.vue?vue&type=script&lang=js&"
export * from "./IncentifyerAccountsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports